import { connect } from 'react-redux'
import { getPrice } from '../modules/home'
import HomeComponent from '../components/HomeView'

const mapDispatchToProps = {
  getPrice
}

const mapStateToProps = (state) => ({
  events: state.events.events,
  isLoading: state.events.isLoading,
  hasLoaded: state.events.hasLoaded
})

export default connect(mapStateToProps, mapDispatchToProps)(HomeComponent)



// WEBPACK FOOTER //
// ./src/routes/Home/containers/Home.container.js